import React, { memo, useEffect, useState } from 'react'
import RadioButton from './RadioButton'

const RadioGroup = ({ items, getValue }) => {
  const [checkedValue, setCheckedValue] = useState(items[0].id)

  const handleChange = (val) => {
    setCheckedValue(val)
    getValue && getValue(val)
  }

  useEffect(() => getValue(checkedValue), [checkedValue])

  return (
    <div className="radio-group">
      {items?.map((item) => (
        <RadioButton
          key={item}
          item={item}
          checked={checkedValue === item.id}
          onChange={handleChange}
        />
      ))}
    </div>
  )
}

export default memo(RadioGroup)
